import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { CssBaseline } from '@mui/material';
import { BrowserRouter } from 'react-router-dom';
import { MuiNotifyProvider } from "muinotify";


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <CssBaseline />
        <MuiNotifyProvider
          maxNotif={4}
          position="top-right"
          wrapperElement="section"
          wrapperName="amir-rezvani"
          StackProps={{ spacing: 1, direction: "column-reverse" }}
          TransitionProps={{ direction: "left" }}
          generalTimeOut={3000}
          defaultSeverity="error"
        >
          <App />
      </MuiNotifyProvider>
    </BrowserRouter>
    
  </React.StrictMode>
);


  